import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "search",
    "category",
    "section",
    "mediaType",
    "activeOnly",
    "body",
    "row",
    "visibleCount",
    "empty"
  ]
  static values = { total: Number }

  declare searchTarget: HTMLInputElement
  declare categoryTarget: HTMLSelectElement
  declare sectionTarget: HTMLSelectElement
  declare mediaTypeTarget: HTMLSelectElement
  declare activeOnlyTarget: HTMLInputElement
  declare bodyTarget: HTMLElement
  declare rowTargets: HTMLElement[]
  declare visibleCountTarget: HTMLElement
  declare emptyTarget: HTMLElement
  declare totalValue: number

  connect(): void {
    this.restoreFromUrl()
    this.filter()
  }

  filter(): void {
    const search = this.searchTarget.value.trim().toLowerCase()
    const category = this.categoryTarget.value
    const section = this.sectionTarget.value
    const mediaType = this.mediaTypeTarget.value
    const activeOnly = this.activeOnlyTarget.checked

    let visible = 0
    this.rowTargets.forEach((row) => {
      const matchesSearch = !search || (row.dataset.search ?? "").includes(search)
      const matchesCategory = !category || row.dataset.category === category
      const matchesSection = !section || row.dataset.section === section
      const matchesMedia = !mediaType || (row.dataset.mediaTypes ?? "").split(",").includes(mediaType)
      const matchesActive = !activeOnly || row.dataset.active === "true"

      const show = matchesSearch && matchesCategory && matchesSection && matchesMedia && matchesActive
      row.hidden = !show
      if (show) visible++
    })

    this.visibleCountTarget.textContent = String(visible)
    this.emptyTarget.classList.toggle("hidden", visible !== 0 || this.totalValue === 0)
    this.updateUrl(search, category, section, mediaType, activeOnly)
  }

  reset(): void {
    this.searchTarget.value = ""
    this.categoryTarget.value = ""
    this.sectionTarget.value = ""
    this.mediaTypeTarget.value = ""
    this.activeOnlyTarget.checked = false
    this.filter()
  }

  private restoreFromUrl(): void {
    const params = new URLSearchParams(window.location.search)
    this.searchTarget.value = params.get("q") ?? ""
    this.categoryTarget.value = params.get("category") ?? ""
    this.sectionTarget.value = params.get("section") ?? ""
    this.mediaTypeTarget.value = params.get("media") ?? ""
    this.activeOnlyTarget.checked = params.get("active") === "1"
  }

  private updateUrl(
    search: string,
    category: string,
    section: string,
    mediaType: string,
    activeOnly: boolean
  ): void {
    const params = new URLSearchParams()
    if (search) params.set("q", search)
    if (category) params.set("category", category)
    if (section) params.set("section", section)
    if (mediaType) params.set("media", mediaType)
    if (activeOnly) params.set("active", "1")
    const qs = params.toString()
    const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname
    window.history.replaceState(null, "", url)
  }
}
